// extracted by mini-css-extract-plugin
export var active = "_9w-7";
export var container = "_9w-0";
export var evenWidth = "_9w-4";
export var large = "_9w-5";
export var outlet = "_9w-8";
export var slide = "_9w-2";
export var small = "_9w-6";
export var tab = "_9w-3";
export var tabs = "_9w-1";